export const initialContext = {
    requestUrl: (window.API_URL + window.PATH)
};
